/**
 * @flow
 * @relayHash 10b5d981f0426a9948ce06298e47ffe8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EditorFooter_proposal$ref = any;
type ProposeNowButton_proposal$ref = any;
export type DeleteProposalChangeInput = {|
  clientMutationId?: ?string,
  context: MutationContext,
  changeId: string,
  meetingId?: ?string,
|};
export type MutationContext = {|
  organizationId: string
|};
export type DeleteProposalChangeMutationVariables = {|
  input: DeleteProposalChangeInput
|};
export type DeleteProposalChangeMutationResponse = {|
  +deleteProposalChange: ?{|
    +deletedChangeId: string,
    +proposal: ?{|
      +$fragmentRefs: EditorFooter_proposal$ref & ProposeNowButton_proposal$ref
    |},
  |}
|};
export type DeleteProposalChangeMutation = {|
  variables: DeleteProposalChangeMutationVariables,
  response: DeleteProposalChangeMutationResponse,
|};
*/


/*
mutation DeleteProposalChangeMutation(
  $input: DeleteProposalChangeInput!
) {
  deleteProposalChange(input: $input) {
    deletedChangeId
    proposal {
      ...EditorFooter_proposal
      ...ProposeNowButton_proposal
      id
    }
  }
}

fragment EditorFooter_proposal on Proposal {
  id
  status
  ...PartSelector_proposal
}

fragment ElectRoleFillerSelect_proposal on Proposal {
  databaseId
  availableElectedRoles: availableRoles(elected: true) {
    edges {
      currentlyHoldingElection
      node {
        databaseId
        localizedName
        id
      }
    }
  }
}

fragment PartSelector_proposal on Proposal {
  id
  tension {
    body
    id
  }
  availableSupportedRoles {
    edges {
      node {
        id
      }
    }
  }
  ...RoleSelect_proposal
  ...PolicySelect_proposal
  ...SupportedRoleSelect_proposal
  ...ElectRoleFillerSelect_proposal
}

fragment PolicySelect_proposal on Proposal {
  databaseId
  availablePolicies {
    edges {
      currentlyUpdating
      node {
        databaseId
        title
        domain {
          databaseId
          id
        }
        id
      }
    }
  }
}

fragment ProposeNowButton_proposal on Proposal {
  ...ProposeNow_proposal
}

fragment ProposeNow_proposal on Proposal {
  id
  status
  databaseId
  canBeAccepted
  hasChanges
  expectedResponseCount
  organization {
    asyncProposalsAreEnabled
    id
  }
  circle {
    isGovernanceEnabled
    id
  }
}

fragment RoleSelect_proposal on Proposal {
  databaseId
  viewerCanLinkRole
  organization {
    onRestrictedPlan
    isOnV5
    id
  }
  circle {
    databaseId
    id
  }
  availableRoles {
    edges {
      currentlyUpdating
      node {
        databaseId
        localizedName
        isLinked
        id
      }
    }
  }
}

fragment SupportedRoleSelect_proposal on Proposal {
  databaseId
  availableSupportedRoles {
    edges {
      currentlyUpdating
      node {
        databaseId
        localizedName
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedChangeId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentlyUpdating",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteProposalChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteProposalChangePayload",
        "kind": "LinkedField",
        "name": "deleteProposalChange",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Proposal",
            "kind": "LinkedField",
            "name": "proposal",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditorFooter_proposal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProposeNowButton_proposal"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteProposalChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteProposalChangePayload",
        "kind": "LinkedField",
        "name": "deleteProposalChange",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Proposal",
            "kind": "LinkedField",
            "name": "proposal",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tension",
                "kind": "LinkedField",
                "name": "tension",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailableSupportedRolesConnection",
                "kind": "LinkedField",
                "name": "availableSupportedRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableSupportedRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLinkRole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onRestrictedPlan",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOnV5",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "asyncProposalsAreEnabled",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Circle",
                "kind": "LinkedField",
                "name": "circle",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGovernanceEnabled",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailableRolesConnection",
                "kind": "LinkedField",
                "name": "availableRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isLinked",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailablePoliciesConnection",
                "kind": "LinkedField",
                "name": "availablePolicies",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailablePoliciesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Policy",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Domain",
                            "kind": "LinkedField",
                            "name": "domain",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "availableElectedRoles",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "elected",
                    "value": true
                  }
                ],
                "concreteType": "AvailableRolesConnection",
                "kind": "LinkedField",
                "name": "availableRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentlyHoldingElection",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "availableRoles(elected:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canBeAccepted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasChanges",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expectedResponseCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "10b5d981f0426a9948ce06298e47ffe8",
    "metadata": {},
    "name": "DeleteProposalChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b5b0b2a0670e8b1d02ddf429732b32f0';

module.exports = node;
